import { IconWrapper } from './styles'

interface ListItemIconProps {
  icon: React.ReactNode
}

export const ListItemIcon = ({ icon }: ListItemIconProps) => {
  return <IconWrapper data-testid="list-item-icon">{icon}</IconWrapper>
}
